

export const SIGNUP_REQUEST = "SIGNUP_REQUEST" ;

export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";

export const SIGNUP_FAILED  = "SIGNUP_FAILED";


